import React from "react";
import {
  Table,
  Input,
  Button as AntdButton,
  DatePicker,
  message,
  Col,
  Row,
  Spin,
  Popover
} from "antd";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import { withActions, isBusy } from "actionware";
import { push } from "connected-react-router";
import { bindActionCreators } from "redux";
import * as numeral from "numeral";
import moment from "moment";
import { json2csv, csv2json } from "json-2-csv";
import InlineSVG from "react-inlinesvg";

import {
  moneyFormat,
  dateFormat,
  jsonDateFormat,
  reportType,
} from "../../common/constants";
import { getLenderId } from "../../common/helpers";
import settingIcon from "../../assets/setting_logo.svg";
import { getFallbackProductCode } from "../fundingLimit/fundingLimitComponents/utils";

import AppTableNoData from "./appTableNoData";
import {
  getApplication,
  downloadReport,
  toggleApplicationApprovalModal,
  approvalModalDetail,
} from "./applicationApprovalActions";
import ApplicationApprovalModal from "./applicationApprovalModal";
import "./application.less";
import  BorrowerDetails  from "../borrower/borrowerDetails";
import { Link } from "react-router-dom";

const { RangePicker } = DatePicker;
@connect(
  ({
    localize,
    applicationApproval: {
      showingApplicationApprovalModal,
      applications: { lists, summary, totalData },
      productBorrowerMapping,
    },
    session: { user },
  }) => ({
    translate: getTranslate(localize),
    showingApplicationApprovalModal,
    user,
    lists,
    summary,
    totalData,
    productBorrowerMapping,
    loading: isBusy(getApplication),
  }),
  (dispatch) => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({
  toggleApplicationApprovalModal,
  getApplication,
  approvalModalDetail,
  downloadReport,
})
class Application extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedRowKeys: [],
      selectedRows: [],
      currentLenderId: null,
      settingsClicked: false,
    };
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleDownloadReport = this.handleDownloadReport.bind(this);
  }
  async componentWillMount() {
    const lenderId = await getLenderId();
    this.setState({ currentLenderId: lenderId });
  }
  onClickApprove = (content, modalType = "approve", bulk = false) => {
    this.props.approvalModalDetail(content);
    this.props.toggleApplicationApprovalModal({ modalType, bulk });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedRows });
  };

  onClickSettings = () => {
    //this.setState({ settingsClicked: true });
    this.props.setViewToSettingsPage();
  };

  handleRowClick = (content, b) => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length <= 1) {
      const { approvalModalDetail, toggleApplicationApprovalModal } =
        this.props;
      approvalModalDetail(content);
      toggleApplicationApprovalModal({ modalType: "all" });
    }
  };

  handlePaginationChange(current, size) {
    const { currentLenderId } = this.state;
    const params = {
      page: current,
      size,
      status: "pending",
      lender_id: currentLenderId,
      sort_field: "submission_date",
      sort_order: "desc",
    };
    this.props.getApplication(params);
  }

  handleTableChange(pagination, filters, sorter) {
    const { submission_date, expiration_date, lender_id, ...restfilters } =
      filters;
    const sorters = {
      sort_field: sorter.field,
      sort_order: sorter.order ? sorter.order.split("end")[0] : undefined,
    };
    const { currentLenderId } = this.state;
    const params = {
      page: pagination.current,
      size: pagination.pageSize,
      status: "pending",
      sort_field: "submission_date",
      sort_order: "desc",
      lender_id: lender_id && lender_id.length > 0 ? lender_id : currentLenderId,
      ...(submission_date &&
        submission_date.length > 0 && {
          submission_date_from: moment(submission_date[0])
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          submission_date_to: moment(submission_date[1])
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
        }),
      ...(expiration_date &&
        expiration_date.length > 0 && {
          expiration_date_from: moment(expiration_date[0])
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          expiration_date_to: moment(expiration_date[1])
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
        }),
      ...restfilters,
      ...sorters,
    };
    this.setState({ changeParams: params });
    this.props.getApplication(params);
  }

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
  };

  handleDownloadReport = () => {
    const { downloadReport, role } = this.props;
    const { currentLenderId, changeParams, selectedRows } = this.state;
    const today = moment().format(jsonDateFormat);
    const parsedRow = selectedRows.map((row) => ({
      ...row,
      interest_fee: row.interest_fee.toString(),
      submission_date: moment(row.submission_date).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      expiration_date:
        moment(row.expiration_date).format("YYYY-MM-DD") !==
        moment("1/1/1970").format("YYYY-MM-DD")
          ? moment(row.expiration_date).format("YYYY-MM-DD HH:mm:ss")
          : "-",
    }));
    const keys = [
      { field: "application_id", title: "Application ID" },
      { field: "submission_date", title: "Tgl Pengajuan" },
      { field: "loan_amount", title: "Jumlah Pinjaman" },
      { field: "tenure", title: "Tenor" },
      { field: "product", title: "Produk" },
      { field: "interest_fee", title: "Interest Fee" },
      { field: "pefindo_collectability", title: "Pefindo" },
      { field: "segmentation", title: "Segment" },
    ];
    if (role && role !== "LENDER")
      keys.push({ field: "lender_id", title: "Lender ID" });
    if (parsedRow.length > 0) {
      return json2csv(
        parsedRow,
        (err, csv) => {
          const csvBlob = new Blob([csv], { type: "type/csv" });
          const url = window.URL.createObjectURL(csvBlob);
          const shadowLinkTag = document.createElement("a");
          shadowLinkTag.href = url;
          shadowLinkTag.download = `Pinjaman_Untuk_Disetujui_${currentLenderId ? "(" + currentLenderId + ")_" : ""}(${today}).csv`;
          shadowLinkTag.click();
        },
        {
          keys,
        }
      );
    }
    const params = {
      report_type: reportType.approval,
      lender_id: currentLenderId,
      status: "pending",
      ...changeParams,
    };
    downloadReport(params).then(({ data }) => {
      if (!data || Object.keys(data).length < 1) {
        return message.error("Empty report");
      }
      const fieldInCsv = [
        "ID",
        "Tgl Pengajuan",
        "Jumlah Pinjaman",
        "Tenor",
        "Produk",
        "Interest Fee",
        "Pefindo",
        "Segment",
      ];
      return csv2json(data, (err, array) => {
        return json2csv(
          array,
          (err, csv) => {
            const csvBlob = new Blob([csv], { type: "type/csv" });
            const url = window.URL.createObjectURL(csvBlob);
            const shadowLinkTag = document.createElement("a");
            shadowLinkTag.href = url;
            shadowLinkTag.download = `Pinjaman_Untuk_Disetujui_${currentLenderId ? "(" + currentLenderId + ")_" : ""}(${today}).csv`;
            shadowLinkTag.click();
          },
          {
            keys: fieldInCsv,
          }
        );
      });
    });
  };

  getColumnFilterInput = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <AntdButton
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </AntdButton>
        <AntdButton
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </AntdButton>
      </div>
    ),
  });


  getFiltersMenuTenure = (dataIndex, data) => ({
    filters:
      data &&
      data.map((item) => ({
        text: `${item} Bulan`,
        value: item,
      })),
  });



  renderBorrowerDetailsUI = (row) => {
    return ( <BorrowerDetails row={row} /> );
  };

  getColumnFilterDate = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <RangePicker
          placeholder={`Select ${dataIndex}`}
          format="YYYY-MM-DD HH:mm:ss"
          style={{ width: 188, marginBottom: 8, display: "block" }}
          onChange={(value, dateString) => {
            setSelectedKeys(dateString);
          }}
        />
        <AntdButton
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </AntdButton>
        <AntdButton
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </AntdButton>
      </div>
    ),
  });

  renderActionableButtons = (
    role,
    selectedRows,
    hasSelected,
    selectedRowKeys
  ) => {
    const { translate } = this.props;
    // role && ["LENDER"].includes(role)
    if (hasSelected) {
      return (
        <Row className="approval-table-header">
          <Col span={6} className="approval-table-title">
            {translate("approvalPage.lender_admin_heading_pending_loans")}
          </Col>
          <Col span={12} offset={6} className="approval-table-btns">
            <span className="approval-table-btn-text">
              {translate(
                "approvalPage.lender_admin_label_loans_selected_count"
              ).replace("${loanCount}", selectedRowKeys.length)}
            </span>
            <AntdButton
              className="approval-table-btn-reject"
              type="default"
              onClick={() => this.onClickApprove(selectedRows, "reject", true)}
              disabled={!hasSelected}
            >
              {translate("approvalPage.lender_admin_button_reject")}
            </AntdButton>
            <AntdButton
              className="approval-table-btn-approve"
              type="primary"
              onClick={() => this.onClickApprove(selectedRows, "approve", true)}
              disabled={!hasSelected}
            >
              {translate("approvalPage.lender_admin_button_approve")}
            </AntdButton>
          </Col>
        </Row>
      );
    }
    return (
      <Row className="approval-table-header">
        <Col span={7} className="approval-table-title">
          {translate("approvalPage.lender_admin_heading_pending_loans")}
        </Col>
        <Col span={8} offset={9} className="approval-table-btns">
          <AntdButton
            type="default"
            className="approval-table-btn-setting"
            onClick={() => this.onClickSettings()}
          >
            <InlineSVG src={settingIcon} />
            {translate("approvalPage.lender_admin_button_settings")}
          </AntdButton>
        </Col>
      </Row>
    );
  };

  render() {
    const { lists, translate, role, totalData, loading } = this.props;
    const { selectedRowKeys, selectedRows } = this.state;
    const columns = [
      {
        title: translate("applicationTableV2.submission_date"),
        dataIndex: "submission_date",
        key: "submission_date",
        ...this.getColumnFilterDate("submission_date"),
        sorter: (a, b) => a.submission_date - b.submission_date,
        render: (value) => moment(value).format(dateFormat),
      },
      {
        title: translate("applicationTableV2.borrower_name"),
        dataIndex: "borrower_name",
        key: "borrower_name",
        render: (text, row, index) => {
          return this.renderBorrowerDetailsUI(row);
        },
      },
      {
        title: translate("applicationTableV2.application_id"),
        dataIndex: "application_id",
        key: "application_id",
        ...this.getColumnFilterInput("application_id"),
        render: (text, row, index) => {
        return (
          <Link
            to={{
              pathname: `/loan/details/${row.application_id}`,
              state: role === "LENDER" ? {  from: '/approval', status: row.status } : {  from: '/approval', lenderId: row.lender_id, status: row.status }
            }}
          >
            {text}
          </Link>
          );
        },
      },
      {
        title: translate("applicationTableV2.product"),
        dataIndex: "product",
        key: "product",
        ...this.getColumnFilterInput("product"),
        render: (value) => value && value.toUpperCase(),
      },
      {
        title: translate("applicationTableV2.purpose"),
        dataIndex: "purpose",
        key: "purpose",
      },
      {
        title: translate("applicationTableV2.loan_amount"),
        dataIndex: "loan_amount",
        key: "loan_amount",
        sorter: true,
        ...this.getColumnFilterInput("loan_amount"),
        render: (value) => numeral(value).format(moneyFormat),
        align: "right",
      },
      {
        title: translate("applicationTableV2.tenure"),
        dataIndex: "tenure",
        key: "tenure",
        sorter: (a, b) => a.tenure - b.tenure,
        render: (value) => `${value} ${translate("applicationTableV2.day")}`,
      },
      {
        title: translate("applicationTableV2.interest"),
        dataIndex: "interest",
        key: "interest",
        sorter: (a, b) => a.interest - b.interest,
        render: (value) => `${value}%`,
      },
      {
        title: translate("applicationTableV2.other_fees"),
        children: [
          {
            title: translate("applicationTableV2.admin_fee"),
            dataIndex: "admin_fee",
            key: "admin_fee",
          },
          {
            title: translate("applicationTableV2.service_fee"),
            dataIndex: "service_fee",
            key: "service_fee",
          },
          {
            title: translate("applicationTableV2.penalty"),
            dataIndex: "penalty",
            key: "penalty",
          },
        ],
      },
      {
        title: translate("applicationTableV2.partner_score"),
        dataIndex: "ofin_credit_score",
        key: "ofin_credit_score",
      },
    ];

    let locale = {
      emptyText: (
        <AppTableNoData
          title={this.props.translate(
            "approvalPage.lender_admin_heading_all_done_approval"
          )}
          subTitle={this.props.translate(
            "approvalPage.lender_admin_body_all_loans_cleared_approval"
          )}
        />
      ),
    };

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User", // Column configuration not to be checked
      }),
    };

    // usage in table component below under onRow property
    // onRow={rowClick}
    // disabled now as per request of product
    const rowClick = (record, rowIndex) => {
      return {
        onClick: () => this.handleRowClick(record, rowIndex),
      };
    };

    const hasSelected = selectedRowKeys.length > 0;
    let uniqueId = 0;
    return (
      <div>
        <div className={`table-application`}>
          {this.renderActionableButtons(
            role,
            selectedRows,
            hasSelected,
            selectedRowKeys
          )}
          <Table
            rowSelection={rowSelection}
            dataSource={lists}
            columns={columns}
            bordered
            loading={loading}
            rowKey={(record) => {
              if (!record.__uniqueId) {
                record.__uniqueId = ++uniqueId;
              }
              return record.__uniqueId;
            }}
            pagination={{
              total: totalData,
              defaultPageSize: 10,
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50"],
              onShowSizeChange: this.handlePaginationChange,
            }}
            tableLayout="auto"
            onChange={this.handleTableChange}
            locale={locale}
          />
        </div>
        <ApplicationApprovalModal role={role} />
      </div>
    );
  }
}

export default Application;
